import $ from 'jquery';
import { controlNav, changeHeaderOnScroll, normalizeHeader } from './header.js';
import { mobileDropdown, hoverHandler } from './nav.js';
import { setYear } from './footer.js';
import { getScreenSize, followLink, toggleCollapse, closeAlert, cookieConsent } from './helpers.js';

// Globals
// Arrray containing the 'transient' listeners that are reevaluated on a resize event 
var transient_listeners = [];

// Init on document ready
$(init);
$(window).on('load', resize);

function init() {
    $(window).on('resize', resize);
    // condition: presence of a 'banner', normalize header if banner present and set padding for 'main' if not
    if ($(".banner").length > 0) {
        normalizeHeader();
        $(window).on('scroll', changeHeaderOnScroll);
    } else {
        // set padding-top for element main on pages without a banner to 100px on mobile devices and 115 px on big screens (necessary since header is fixed and it height increases on the breakpoint of 1000px)
        $("main").css('padding-top', $('header').outerHeight(false));
        $("header").css("--bg-color", "#f10b02ff");
    }
    $(".dropdown .dropdown-list .dropdown-item").on('click', (e) => followLink($(e.delegateTarget).attr('href'), false));
    if (!document.cookie.includes("cookieConsent=1")) {
        $(".cookie-banner").css('display', 'flex');
        $(".cookie-banner .close-button").on('click', cookieConsent);
    }
    // add event handlers for buttons on collection pages
    if ($(".button.back").length > 0)
        $(".button.back").on('click', () => window.history.back());
    if ($(".button.apply").length > 0)
        $(".button.apply").on('click', (e) => window.location.assign('mailto:mitmachen@sghaitz.de?subject=' + $(e.delegateTarget).attr('subject') + ' bei der SG Haitz'));

    // Global listener for buttons with href attribute
    $(".button[href]").on('click', (e) => followLink($(e.delegateTarget).attr('href'), true));
    // PopUp
    cookieStore.get('popUpSeen').then((cookie) => {
        if (cookie == null) {
            $.ajax(API_HOST + "/popup", {
                timeout: 10000
            }).done((popup) => {
                if (popup.length > 0) {
                    popup = popup[0];
                    $('.popup.content').attr('href', popup.url);
                    $('.popup.image img').attr('src', '/assets/images/popups/' + popup.imgSrc);
                    $('.popup.text').html(popup.text);
                    $(".popup.content").on('click', (e) => {
                        window.cookieStore.set({
                            // expires after one day
                            expires: Date.now() + 86400000,
                            name: 'popUpSeen',
                            value: '1',
                            sameSite: 'lax'
                        });
                        followLink($(e.delegateTarget).attr('href'), true);
                    });
                    $('.popup').slideDown(200, (element) => {
                        if (!popup.text) {
                            $('.popup.text').css('display', 'none');
                        }
                    });
                    $(".popup .button.close, .popup.canva").on('click', () => {
                        $(".popup").slideUp(200);
                        window.cookieStore.set({
                            // expires after one day
                            expires: Date.now() + 86400000,
                            name: 'popUpSeen',
                            value: '1',
                            sameSite: 'lax'
                        });
                    });
                }
            });
        }
    });

    // Page
    switch (window.location.pathname) {
        case '/':
            initHome(); break;
        case '/soccer/':
        case '/soccer/index.html':
            initDepartment();
            initSoccer();
            break;
        case '/cheer/':
        case '/cheer/peewee':
        case '/cheer/junior':
        case '/cheer/senior':
            initDepartment();
            initCheer();
            break;
        case '/contact':
        case '/contact.html':
            initContact();
            break;
        case '/blog':
        case '/blog.html':
            initBlog();
            break;
        case '/sponsoring':
        case '/sponsoring.html':
            initSponsoring();
            break;
        case '/club/':
        case '/club.html':
            initClub();
            break;
        case '/club/sponsors':
        case '/club/sponsors.html':
            initSponsors();
            break;
        case '/club/part':
        case '/club/part.html':
            initPart();
            break;
        default:
            break;
    }
    // Footer
    setYear();
}

function resize() {
    var screen_size = getScreenSize();
    // remove 'transient' listeners which are dependent on screen size
    while (transient_listeners.length > 0) {
        transient_listeners.pop().off();
    }
    // reset display property for 'nav' element
    $("nav").css("display", "");
    // condition: screen width, enable handlers for mobile nav on mobile devices and dropdown handlers on big screens
    if (screen_size < 2) {
        transient_listeners.push(
            $(".dropdown-btn").on('click', (e) => mobileDropdown(e)),
            $("#menu-btn").on('click', (e) => controlNav(e)),
        );
    } else {
        transient_listeners.push($(".dropdown").on("mouseenter", (e) => hoverHandler(e)).on("mouseleave", (e) => hoverHandler(e)));
    }
    if ($('body').outerHeight(true) < $(window).outerHeight()) $("footer").css('margin-top', $(window).outerHeight() - $('body').outerHeight(true));
}

async function initHome() {
    const {
        loadNews
    } = await import('./index.js');

    // Initialization
    loadNews();
}

async function initDepartment() {
    const { activateImageGallery } = await import('./department.js');
    // Department
    activateImageGallery();
}

async function initSoccer() {
    await import('./soccer.js');
    window.cookieStore.get('women-expanded').then((cookie) => {
        cookie != null && toggleCollapse($('.team-section#women .collapsable-header'));
    });
    window.cookieStore.get('juniors-expanded').then((cookie) => {
        cookie != null && toggleCollapse($('.team-section#juniors .collapsable-header'));
    });
    // Listeners 
    $(".collapsable-header").on('click', (e) => {
        toggleCollapse(e.delegateTarget);
        if ($(e.delegateTarget).hasClass('collapsed')) {
            window.cookieStore.delete($(e.delegateTarget).parent(".team-section").attr('id') + "-expanded");
        } else {
            window.cookieStore.set($(e.delegateTarget).parent(".team-section").attr('id') + "-expanded", "1");
        }
    });
    $(".contact-button").on('click', (e) => followLink($(e.delegateTarget).attr('href'), false));
}

async function initCheer() {
    // Listeners
    $(".category-container").on('click', (e) => followLink("/cheer/" + $(e.delegateTarget).attr('name'), false));
    $(".contact-button").on('click', (e) => followLink($(e.delegateTarget).attr('href'), false))
}

async function initContact() {
    const { showSubjects, submitForm } = await import('./contact.js');
    // Listeners
    $("select#department").on('change', showSubjects);
    $("form").on("submit", (e) => submitForm(e));
    $(".alert .close").on('click', closeAlert);
}

function initBlog() {
    $.get(HOME_URL + "/assets/svg/pen-square.svg", (svg) => $('.post-author').prepend(svg), 'text');
    $.get(HOME_URL + "/assets/svg/hashtag.svg", (svg) => $('.post-categories').prepend(svg), 'text');
}

function initPart() {
    $('.position').on('click', (e) => followLink($(e.delegateTarget).attr('href'), false));
}

function initSponsors() {
    $(".sponsor-image").on('click', (e) => {
        if ($(e.delegateTarget).attr('href') != '#') followLink($(e.delegateTarget).attr('href'), true);
    })
}

function initSponsoring() {
    $('.download-button').on('click', (e) => followLink($(e.delegateTarget).attr('src'), true));
}